import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorToasterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#DC3636"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7279 10L9.99998 22.7279",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7279 22.7279L9.99998 9.99998",
			stroke: "white",
			strokeWidth: 1.5
		})
	]
});
export default SvgErrorToasterIcon;
